import { mockBuilder } from '../../utils/builderHelper.es.js';
import { anInvoicePreviewMultiProducts, anInvoicePreviewMultiProductsFree } from './InvoicePreviewMultiProducts.mock.es.js';
import { PreparePurchase } from './PreparePurchase.es.js';

/** @module Mocks */ /** typedoc */
function aPreparePurchase() {
    return mockBuilder(new PreparePurchase())
        .withInvoicePreview(anInvoicePreviewMultiProducts())
        .withToken('prepare-token')
        .withHasPaymentMethod(true)
        .withHasValidBillingAddress(true);
}
function aPreparePurchaseFree() {
    return mockBuilder(new PreparePurchase())
        .withInvoicePreview(anInvoicePreviewMultiProductsFree())
        .withToken('prepare-token')
        .withHasPaymentMethod(true)
        .withHasValidBillingAddress(true);
}

export { aPreparePurchase, aPreparePurchaseFree };
